import script from "./TeachingProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TeachingProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./TeachingProjectForm.vue?vue&type=style&index=0&id=73ce55fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ce55fe"]])

export default __exports__